// eslint-disable-next-line no-restricted-imports
import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

const customTwMerge = extendTailwindMerge({
  extend: {
    theme: {
      spacing: [
        '2xs',
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        '2xl',
        '3xl',
        '4xl',
        '5xl',
        '6xl',
        '7xl',
        '8xl',
        '9xl',
        '10xl',
        '11xl',
      ],
    },
    classGroups: {
      'shadow': [
        {
          shadow: ['nav', 'layer', 'dropdown'],
        },
      ],
      'font-size': [
        {
          size: [
            'heading-xs',
            'heading-sm',
            'heading-md',
            'heading-lg',
            'heading-xl',
            'heading-2xl',
            'subheading-xs',
            'subheading-sm',
            'subheading-md',
            'subheading-lg',
            'subheading-xl',
            'subheading-2xl',
            'body-xs',
            'body-sm',
            'body-md',
            'body-lg',
            'quote-sm',
            'quote-md',
            'quote-lg',
            'button-sm',
            'button-md',
            'button-lg',
            'overline-xs',
            'overline-sm',
            'overline-md',
            'overline-lg',
          ],
        },
      ],
    },
  },
})

export const cn = (...v: ClassValue[]) => customTwMerge(clsx(v))
